// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg.active[data-v-051df196]{color:#0078b6!important}svg.inactive[data-v-051df196]{color:#dee5ea!important}", ""]);
// Exports
module.exports = exports;
